import { createReducer } from '../store.model';

import {
    ActionType,
    CloseAllCharts,
    Reload,
    ReloadResult,
    RootClearStateAction,
} from './my-coaching-card.action';
import { CoachingCardState, defaultState } from './my-coaching-card.state';
import { handleReloadResult } from './state/handle-reload-result.function';
const { builder, reducer } = createReducer<ActionType, CoachingCardState>(
    defaultState(),
);

builder.add<Reload>(ActionType.MY_COACHING_CARD__ROOT__RELOAD, (state) => {
    return {
        ...state,
        pending: {
            ...state.pending,
            reload: true,
            hasData: true,
        },
    };
});

builder.add<ReloadResult>(
    ActionType.MY_COACHING_CARD__ROOT__RELOAD_RESULT,
    handleReloadResult,
);

builder.add<CloseAllCharts>(
    ActionType.MY_COACHING_CARD_CLOSE_ALL_CHARTS,
    (state) => {
        const newSelectedRows = Object.keys(state.selectedRows).reduce(
            (acc, key) => {
                acc[key] = false;
                return acc;
            },
            {},
        );

        return {
            ...state,
            selectedRows: newSelectedRows,
        };
    },
);

builder.add<RootClearStateAction>(
    ActionType.MY_COACHING_CARD_ROOT__CLEAR_STATE,
    () => {
        return defaultState();
    },
);

export const coachingCardReducer = reducer;
